import React, { useState, useEffect } from "react"
import { Redirect, useHistory } from "react-router-dom"

import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Grid from "@material-ui/core/Grid"
import { Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Snackbar from "@material-ui/core/Snackbar"
import MuiAlert from "@material-ui/lab/Alert"
import { Skeleton } from "@material-ui/lab"
import WithDrawer from "../components/common/drawer/withDrawer"
import { ViewerHeader, FileViewer, ViewerAdditionalDetails, ViewerDocumentList, NativeView } from "../components/viewer"
import { getInfo, getRetainFiltersList, getRetainFiltersSuccess } from "../actions/infoActions"
import {
	getFileRowClickRequest,
	getFileRequestByPage,
	resetPageViewerData,
	getPageNumberBasedOnFileIdRequest,
	getPageNumberBasedOnHighlightTextReset,
	getPageNumberBasedOnHighlightTextRequest,
} from "../actions/documentModalActions"
import Notification from "../components/Notification/Notification"
import { getConceptBasedOnId, resetHighlightFilter, searchHighlightFilter } from "../actions/highlightActions"
import {
	getAnnotation,
	getAuditHistory,
	getChat,
	getViewerAllDocumentsRequest,
	getViewerAllDocumentsRequestReset,
	logAudit,
	updateCurrentSession,
	updateViewerPageNumber,
} from "../actions/viewerActions"
import {
	getReviewBasedOnFileIdRequest,
	getReviewBasedOnFileIdReset,
	getReviewListRequest,
	getReviewRequest,
	reSetReview,
	setIsCaseAdmin,
	setReview,
} from "../actions/reviewActions"
import { requestCustomTags } from "../actions/customTagsActions"
import { LAST_OPENED_FILE_ID, buildQueryString, checkToShowNativeFormat, getQueryParams, payloadParsing } from "../utils"
import PageQAndA from "./PageQAndA"
import { ModalPopup } from "../components/modal"
import FileDeleteModal from "../components/common/FileDeleteModal"
import { setIsFileDeleted } from "../actions/deleteActions"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	root: {
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"&:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "transparent",
		},
	},
	notification: {
		padding: theme.spacing(2, 10),
	},
	fileDeletedModal: {
		width: 400,
	},
	btnRefresh: {
		textTransform: "initial",
	},
}))

const PageViewer = () => {
	const classes = useStyles()
	const history = useHistory()
	const [t] = useTranslation("global")

	const dispatch = useDispatch()
	const location = useLocation()
	const [loading, setLoading] = useState(false)
	const [retainedFilterJobData, setRetainedFilterJobData] = useState(null)
	const [highlightFilterUpdated, setHighlightFilterUpdated] = useState(false)
	const { currentDocument, documentLoading, documentDetails, pageNumberForCurrentDocument, metadata } = useSelector(
		(state) => state.documentModal
	)
	const { allDocuments, allDocumentsCount } = useSelector((state) => state.viewerData)
	const { list: reviewList, review, reviewBasedOnFileId } = useSelector((state) => state.review)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const retainedFilter = useSelector((state) => state.info?.retainedFilterJobData)
	const { id, job_id } = useSelector((state) => state?.review?.review)
	const aiEnabled = useSelector((state) => state?.info?.version?.ai_enabled)
	const isFileDeleted = useSelector((state) => state.deleteFile.isFileDeleted)

	useEffect(() => {
		if (!_.isEmpty(retainedFilter)) {
			setRetainedFilterJobData((prev) => ({ ...retainedFilter }))
			dispatch(getRetainFiltersSuccess())
		}
	}, [retainedFilter])

	useEffect(() => {
		const payload = getQueryParams()
		dispatch(getRetainFiltersSuccess(payload))
	}, [])

	useEffect(() => {
		const filterData = { ...highlightFilter }
		filterData["nativeView"] = !filterData["nativeView"]
		dispatch(searchHighlightFilter(filterData))
		dispatch(resetPageViewerData())
		//dispatch(getRetainFiltersSuccess())
		dispatch(resetHighlightFilter())
		dispatch(getViewerAllDocumentsRequestReset())
		dispatch(updateViewerPageNumber(1))
		if (location?.pathname?.split("/")?.[2]) {
			setLoading(true)
			//dispatch(getRetainFiltersList(location?.pathname?.split("/")?.[2]))
		}
		if (location?.pathname?.split("/")?.[3]?.split("?")[0]) {
			dispatch(getAuditHistory(location?.pathname?.split("/")?.[3]?.split("?")[0]))
			dispatch(getAnnotation(location?.pathname?.split("/")?.[3]?.split("?")[0]))
			dispatch(getReviewBasedOnFileIdRequest(location?.pathname?.split("/")?.[3]?.split("?")[0]))
		}
		return () => {
			dispatch(getRetainFiltersSuccess())
			dispatch(resetPageViewerData())
			dispatch(resetHighlightFilter())
			dispatch(getViewerAllDocumentsRequestReset())
			dispatch(updateViewerPageNumber(1))
			dispatch(reSetReview())
			dispatch(getReviewBasedOnFileIdReset())
			const filterData = { ...highlightFilter }
			filterData["nativeView"] = !filterData["nativeView"]
			dispatch(searchHighlightFilter(filterData))
		}
	}, [])

	useEffect(() => {
		if (documentDetails?.metadata) {
			dispatch(getAnnotation(location?.pathname?.split("/")?.[3]?.split("?")[0], checkToShowNativeFormat(documentDetails?.metadata)))
			const params = location?.pathname?.split("/")
			const fileId = params[params.length - 1]
			const chatPayload = {
				file_ids: [fileId],
			}
			if (aiEnabled) {
				dispatch(getChat(chatPayload))
			}
			dispatch(updateCurrentSession(0))
			const logAuditPayload = {
				entity_id: location?.pathname?.split("/")?.[3]?.split("?")[0],
				entity_type: "file",
				action: "view",
				action_history: {},
				search_context: {
					page_context: location?.pathname?.split("/")[1],
					review_id: retainedFilterJobData?.additional_params?.review_id || "",
				},
				metadata: {
					entity_name: documentDetails?.name,
					entity_subtype: documentDetails?.metadata?.source,
					payload: buildQueryString(getQueryParams()),
				},
				entity_metadata: {
					entity_name: documentDetails?.name,
					entity_subtype: documentDetails?.metadata?.source,
				},
			}

			dispatch(logAudit(logAuditPayload))
		}
	}, [documentDetails?.metadata])

	useEffect(() => {
		if (retainedFilterJobData) {
			const params = location?.pathname?.split("/")
			const fileId = params[params.length - 1]
			let searchText = retainedFilterJobData?.text ? highlightFilter?.searchWord : []
			let selectedConcept = retainedFilterJobData?.text ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}

			dispatch(
				getViewerAllDocumentsRequest({
					params: { ...retainedFilterJobData },
					jobIdToRetainData: null,
				})
			)
			//Commenting this code as we do not need the page number count bases on  document now
			//dispatch(getPageNumberBasedOnFileIdRequest(payload))
			if (
				highlightFilter?.specificWord ||
				!_.isEmpty(retainedFilterJobData?.text) ||
				!_.isEmpty(retainedFilterJobData?.categories) ||
				!_.isEmpty(highlightFilter?.loadedConcept)
			) {
				dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
			}
			if (!_.isEmpty(retainedFilterJobData?.categories)) {
				dispatch(getConceptBasedOnId(retainedFilterJobData?.categories))
			}
			if (!_.isEmpty(retainedFilterJobData?.text)) {
				const filterData = { ...highlightFilter }
				filterData.loadedConcept = [...filterData?.loadedConcept, ...retainedFilterJobData?.text]
				dispatch(searchHighlightFilter(filterData))
			}
		}
	}, [retainedFilterJobData])

	useEffect(() => {
		if (!_.isEmpty(highlightFilter?.loadedConcept)) {
			const params = location?.pathname?.split("/")
			const fileId = params[params.length - 1]
			let searchText = retainedFilterJobData?.text ? highlightFilter?.searchWord : []
			let selectedConcept = retainedFilterJobData?.text ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
	}, [highlightFilter?.loadedConcept])

	useEffect(() => {
		if (!_.isEmpty(allDocuments)) {
			const params = location?.pathname?.split("/")
			const fileId = params[params.length - 1]
			if (id) {
				dispatch(getFileRowClickRequest({ id: fileId, reviewId: id }))
			} else if (retainedFilterJobData?.additional_params?.search_id) {
				dispatch(getFileRowClickRequest({ id: fileId, searchId: retainedFilterJobData?.additional_params?.search_id }))
			} else {
				dispatch(getFileRowClickRequest(fileId))
			}

			dispatch(getFileRequestByPage({ id: fileId, page: 1, reviewId: retainedFilterJobData?.additional_params?.review_id }))
		}
	}, [allDocuments])

	useEffect(() => {
		//if (!_.isEmpty(currentDocument)) {
		setLoading(false)
		//}
	}, [currentDocument])

	useEffect(() => {
		if (highlightFilter) {
			setHighlightFilterUpdated(!highlightFilterUpdated)
		}
	}, [highlightFilter])

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	useEffect(() => {
		dispatch(getReviewListRequest())
		dispatch(requestCustomTags())
	}, [])

	useEffect(() => {
		if (reviewList.length && retainedFilterJobData?.additional_params?.review_id && !review?.id) {
			const id = retainedFilterJobData?.additional_params?.review_id
			const isCaseAdmin = retainedFilterJobData?.additional_params?.is_case_admin || false
			const selectedReview = reviewList?.find((item) => item?.id === id)
			if (selectedReview) {
				dispatch(setIsCaseAdmin(isCaseAdmin))
				dispatch(setReview(selectedReview))
			}
		}
	}, [reviewList, retainedFilterJobData])

	useEffect(() => {
		if (!_.isEmpty(review?.search_criteria?.concept_ids)) {
			dispatch(getConceptBasedOnId(review?.search_criteria?.concept_ids))
		}
		if (!_.isEmpty(review?.search_criteria?.terms)) {
			const filterData = { ...highlightFilter }
			filterData.loadedConcept = [...filterData?.loadedConcept, ...review?.search_criteria?.terms]
			dispatch(searchHighlightFilter(filterData))
		}
	}, [review])

	return (
		<>
			<Grid container spacing={2} className={classes.root}>
				<Grid item xs={12} className={classes.notification}>
					<Notification />
				</Grid>
				<Grid item xs={3}>
					<ViewerDocumentList loading={loading} retainedFilterJobData={retainedFilterJobData} />
				</Grid>
				<Grid item xs={6}>
					{checkToShowNativeFormat(documentDetails?.metadata) ? (
						<NativeView
							retainedFilterJobData={retainedFilterJobData}
							highlightFilter={highlightFilter}
							documentDetails={documentDetails}
						/>
					) : (
						<FileViewer loading={loading} retainedFilterJobData={retainedFilterJobData} />
					)}
				</Grid>

				<Grid item xs={3}>
					<ViewerAdditionalDetails loading={loading} retainedFilterJobData={retainedFilterJobData} />
				</Grid>
				<PageQAndA />
			</Grid>

			<ModalPopup
				className={classes.fileDeletedModal}
				title={
					<Typography variant="body1" style={{ fontWeight: 500 }}>
						This file has been deleted
					</Typography>
				}
				open={isFileDeleted}
				//setOpen={() => dispatch(setIsFileDeleted(false))}
				showClose={false}
				showDivider={false}
			>
				<FileDeleteModal
					content={t("deleteFile.messageViewer")}
					btnText={t("deleteFile.buttonTextViewer")}
					navigate={() => {
						dispatch(setIsFileDeleted(false))
						const path = location?.pathname?.split("/")
						path?.[3] && localStorage?.setItem(LAST_OPENED_FILE_ID, path?.[3])
						history.push(`${path?.[0]}/${path?.[1]}${window.location.search}`)
					}}
				/>
			</ModalPopup>
		</>
	)
}

export default WithDrawer(PageViewer)
